<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.job.searcJob')"
                        height="40px"
                        @keyup.enter="getBranchPagination()"
                        solo>
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        color="primary"
                        outlined
                        height="40px"
                        @click="searchBranch()"
                        class="search-button">
                        {{ $vuetify.lang.t('$vuetify.job.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="permissionCreate"
                    color="primary"
                    height="40px"
                    @click="createBranch()">
                    + {{ $vuetify.lang.t('$vuetify.job.createJob') }}
                    <!-- + Create Branch -->
                </v-btn>
            </div>
        </div>

        <job-form-modal
            ref="branchModal"
            :mode="operationMode"
            :updateBranchId="updateBranchId"
            @success-created="updateBranchsData()"
            @success-updated="updateBranchsData()"
            @close-modal="closeModal()"/>

        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                :headers="headers"
                :items="branches"
                @page-count="pageCount = $event"
                :page.sync="page"
                :options.sync="options"
                :server-items-length="totalBranches"
                :loading="loading">
                <template v-slot:[`item.contact_person`]="{ item }">
                    <div class="line">
                        <div>
                            {{ item.contact_name}}
                            <br>
                            {{ item.contact_number}}
                        </div>
                    </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                        <div class="action">
                            <v-icon
                                v-if="permissionUpdate"
                                class="mr-2"
                                @click="updateBranchInfo(item)">
                                edit
                            </v-icon>
                        </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <delete-modal
            ref="modalDeleteBranch"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>

    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal'
import JobFormModal from '@/components/modal/JobFormModal.vue'
import permissionConstant from '@/constants/permissions.js'
export default {
    name: 'JobsLists',

    components: {
        JobFormModal,
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            branches: [],
            totalBranches: 0,
            loading: false,
            operationMode: '',
            updateBranchId: null,
            branchDeleteId: '',
            permissionCreate: true,
            permissionUpdate: true,
            permissionDelete: true,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.job.jobName'), value: 'name', width: '90%' },
                // { text: this.$vuetify.lang.t('$vuetify.branch.branchAddress'), value: 'address', width: '40%' },
                // { text: this.$vuetify.lang.t('$vuetify.branch.contactPerson'), value: 'contact_person', width: '20%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        }
    },

    methods: {
        async getBranchList () {
            const res = await this.axios.get('branches')
            if (res && res.data && res.data.status === 'ok') {
                this.branches = res.data.data
            }
        },

        createBranch () {
            this.operationMode = 'create'
            this.$refs.branchModal.dialog = true
        },

        updateBranchInfo (branch) {
            this.operationMode = 'update'
            this.updateBranchId = branch.id
            this.$refs.branchModal.dialog = true
        },

        async openModalDelete (branch) {
            this.branchDeleteId = branch.id
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.branch.deleteBranch')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.branch.wantToDelete')} "${branch.name}" ?`
            this.deleteForm.path = `job/delete/${branch.id}`
            this.$refs.modalDeleteBranch.dialog = true
        },

        async deleteSuccess () {
            await this.updateBranchsData()
            if (this.branchDeleteId === localStorage.getItem('currentBranchId') && this.$store.state.branches) {
                this.$store.dispatch('setCurrentBranch', this.$store.state.branches[0])
            }
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.branch.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.branch.branchIsDeleted'),
                type: 'success'
            })
        },

        async updateBranchsData () {
            await this.getBranchPagination()

            // update branch for branch selection component
            await this.$store.dispatch('getBranches')
        },

        async searchBranch () {
            this.options.page = 1
            await this.getBranchPagination()
        },

        async getBranchPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `jobs?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.branches = res.data.data
                this.totalBranches = res.data.total
                this.loading = false
            }
        },

        closeModal () {
            this.operationMode = ''
        },

        checkPermission () {
            this.permissionCreate = this.$util.checkPermission(permissionConstant.branch.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.branch.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.branch.delete)
        }
    },

    mounted () {
        this.checkPermission()
    },

    watch: {
        options: {
            async handler () {
                await this.getBranchPagination()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 18px;
}

.search-container {
    width: 50%;
    display: flex;
    .search-input {
        width: 340px;
    }
    .search-button {
        height: 45px;
    }
}
</style>
